import * as XLSX from "xlsx";

class ExcelExportUtil {
  static exportToExcel(
    columns: any[],
    visibleRows: any[],
    tabName: string,
    fileName: string
  ): void {
    const headers = columns.map((col: any) => col.Header);

    const data = visibleRows.map((row: any) => {
      if (!row) {
        return Array(columns.length).fill("");
      }

      return columns.map((col: any) => {
        const value = row[col.accessor];
        return value !== undefined ? value : "";
      });
    });

    const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, tabName);
    XLSX.writeFile(wb, fileName);
  }

  static transformColumnsToHeaders(columns: any[]): string[] {
    return columns.map((col: any) => col.Header);
  }

  static transformRowsToData(columns: any[], visibleRows: any[]): any[] {
    return visibleRows.map((row: any) => columns.map((col: any) => row.values[col.accessor] || ""));
  }

  static formatCsvDate(date: any) {
    if (!date) return null;
    const parsedDate = new Date(date);
    return new Date(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate());
  }

  static formatLocalDate(dateString: any) {
    const date = new Date(dateString);
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    } as Intl.DateTimeFormatOptions;

    return new Intl.DateTimeFormat("en-US", options).format(date);
  }
}

export default ExcelExportUtil;
